export interface MethodData {
    methodName: string;
    methodArguments: unknown[];
}
